import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, useState, useMemo, useCallback, useEffect, Fragment } from 'react';
import { useMultipleSelection, useSelect } from 'downshift';
import '../../assets/icons/custom/CheckIcon.es.js';
import '../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../assets/icons/generated/filled/CdPauseFilled.es.js';
import CheckCircleFilled from '../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../assets/icons/generated/filled/LockFilled.es.js';
import '../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../assets/icons/generated/filled/StarFilled.es.js';
import '../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../assets/icons/generated/filled/StopFilled.es.js';
import '../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../assets/icons/generated/filled/XFilled.es.js';
import '../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../assets/icons/generated/outlined/AudioLinesOutlined.es.js';
import '../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../assets/icons/generated/outlined/BlocksOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../assets/icons/generated/outlined/CancelOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckOutlined.es.js';
import CheckCircleOutlined from '../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockOutlined.es.js';
import '../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../assets/icons/generated/outlined/FeatherOutlined.es.js';
import '../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../assets/icons/generated/outlined/HandCoinsOutlined.es.js';
import '../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../assets/icons/generated/outlined/HandshakeOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../assets/icons/generated/outlined/MessageCircleHeartOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../assets/icons/generated/outlined/MobilePhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../assets/icons/generated/outlined/PlugOutlined.es.js';
import '../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../assets/icons/generated/outlined/StemsOutlined.es.js';
import '../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../assets/icons/generated/outlined/ThreadOutlined.es.js';
import '../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../assets/icons/generated/outlined/UsersOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../assets/icons/generated/outlined/WaveformMirrorOutlined.es.js';
import '../../assets/icons/generated/products/Blog.es.js';
import '../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../assets/icons/generated/products/Chromatic.es.js';
import '../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../assets/icons/generated/products/Courses.es.js';
import '../../assets/icons/generated/products/Creator.es.js';
import '../../assets/icons/generated/products/Distribution.es.js';
import '../../assets/icons/generated/products/Insider.es.js';
import '../../assets/icons/generated/products/LandrFx.es.js';
import '../../assets/icons/generated/products/Mastering.es.js';
import '../../assets/icons/generated/products/NetworkPro.es.js';
import '../../assets/icons/generated/products/NetworkServices.es.js';
import '../../assets/icons/generated/products/Network.es.js';
import '../../assets/icons/generated/products/Plugins.es.js';
import '../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../assets/icons/generated/products/SamplesDark.es.js';
import '../../assets/icons/generated/products/Samples.es.js';
import '../../assets/icons/generated/products/SessionsDark.es.js';
import '../../assets/icons/generated/products/Sessions.es.js';
import '../../assets/icons/generated/products/Tutorials.es.js';
import '../../assets/icons/generated/products/Vocalign.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { filterChildrenByType } from '../../utils/filterChildrenByType/filterChildrenByType.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import { Center } from '../../primitives/Center/Center.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import Level from '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu.es.js';
import Button from '../Button/Button.es.js';
import { Badge } from '../Badge/Badge.es.js';
import { List } from '../List/List.es.js';
import { Scrollable } from '../Scrollable/Scrollable.es.js';
import { SearchInput } from '../SearchInput/SearchInput.es.js';
import { Text } from '../Text/Text.es.js';
import { Progress } from '../Progress/Progress.es.js';
import { getGroups, getItemsByGroup } from './helpers.es.js';
import { Item, Footer, Header, FilterDropdownCheckbox } from './styled.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var DefaultLoadingComponent = function DefaultLoadingComponent() {
  return (
    /* @__PURE__ */
    React.createElement(Center, {
      py: "md"
    },
    /* @__PURE__ */
    React.createElement(Progress, {
      size: "md"
    }))
  );
};

var FilterDropdownBase = function FilterDropdownBase(_a) {
  var _b = _a,
      items = _b.items,
      label = _b.label,
      _b$triggerKind = _b.triggerKind,
      triggerKind = _b$triggerKind === void 0 ? "solid" : _b$triggerKind,
      TriggerComponent = _b.triggerComponent,
      header = _b.header,
      subheader = _b.subheader,
      onSelect = _b.onSelect,
      _onChange = _b.onChange,
      _b$selectionType = _b.selectionType,
      selectionType = _b$selectionType === void 0 ? "multi" : _b$selectionType,
      _b$selectionStyle = _b.selectionStyle,
      selectionStyle = _b$selectionStyle === void 0 ? "checkbox" : _b$selectionStyle,
      _b$showSelectedItemAs = _b.showSelectedItemAsLabel,
      showSelectedItemAsLabel = _b$showSelectedItemAs === void 0 ? false : _b$showSelectedItemAs,
      _b$initialSelectedIte = _b.initialSelectedItems,
      initialSelectedItems = _b$initialSelectedIte === void 0 ? [] : _b$initialSelectedIte,
      groupBy = _b.groupBy,
      _b$isSearchable = _b.isSearchable,
      isSearchable = _b$isSearchable === void 0 ? true : _b$isSearchable,
      _b$searchPlaceholder = _b.searchPlaceholder,
      searchPlaceholder = _b$searchPlaceholder === void 0 ? "Search..." : _b$searchPlaceholder,
      onSearch = _b.onSearch,
      onReset = _b.onReset,
      helpText = _b.helpText,
      _b$hasFooter = _b.hasFooter,
      hasFooter = _b$hasFooter === void 0 ? false : _b$hasFooter,
      _b$clearLabel = _b.clearLabel,
      clearLabel = _b$clearLabel === void 0 ? "Clear all" : _b$clearLabel,
      _b$confirmLabel = _b.confirmLabel,
      confirmLabel = _b$confirmLabel === void 0 ? "Save" : _b$confirmLabel,
      onClear = _b.onClear,
      onConfirm = _b.onConfirm,
      onOpen = _b.onOpen,
      onClose = _b.onClose,
      isLoading = _b.isLoading,
      _b$loadingComponent = _b.loadingComponent,
      LoadingComponent = _b$loadingComponent === void 0 ? DefaultLoadingComponent : _b$loadingComponent,
      children = _b.children,
      rest = __objRest(_b, ["items", "label", "triggerKind", "triggerComponent", "header", "subheader", "onSelect", "onChange", "selectionType", "selectionStyle", "showSelectedItemAsLabel", "initialSelectedItems", "groupBy", "isSearchable", "searchPlaceholder", "onSearch", "onReset", "helpText", "hasFooter", "clearLabel", "confirmLabel", "onClear", "onConfirm", "onOpen", "onClose", "isLoading", "loadingComponent", "children"]);

  var listRef = useRef(null);

  var _selectionStyle = selectionType === "single" ? "default" : selectionStyle;

  var footer = filterChildrenByType(children, Footer);

  var _useState = useState(null),
      selectedItemValues = _useState[0],
      setSelectedItemValues = _useState[1];

  var _useState2 = useState(""),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var filteredInitialSelectedItems = useMemo(function () {
    var filterInitialItems = function filterInitialItems(items2, filter) {
      var itemKeys = Object.keys(filter);
      return items2.filter(function (item) {
        return itemKeys.every(function (key) {
          return filter[key] === item[key];
        });
      });
    };

    var filteredItems2 = initialSelectedItems.map(function (item) {
      return filterInitialItems(items, item);
    });
    return filteredItems2.length ? filteredItems2.reduce(function (acc, curr) {
      return acc.concat(curr);
    }) : initialSelectedItems;
  }, [initialSelectedItems, items]);

  var _useMultipleSelection = useMultipleSelection({
    initialSelectedItems: filteredInitialSelectedItems
  }),
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem,
      selectedItems = _useMultipleSelection.selectedItems,
      reset = _useMultipleSelection.reset;

  var filteredItems = useMemo(function () {
    var itemsWithIndices = items.map(function (item, index) {
      return __spreadProps(__spreadValues({}, item), {
        index: index
      });
    });

    if (isSearchable) {
      if (inputValue) {
        return itemsWithIndices.filter(function (item) {
          return item.displayValue.toLowerCase().includes(inputValue.toLowerCase());
        });
      } else {
        return itemsWithIndices;
      }
    } else {
      return itemsWithIndices;
    }
  }, [items, inputValue, isSearchable]);
  var groups = useMemo(function () {
    return getGroups(groupBy, items);
  }, [items, groupBy]);
  var groupedItems = useMemo(function () {
    return getItemsByGroup(groupBy, groups, filteredItems);
  }, [groupBy, groups, filteredItems]);
  var isItemSelected = useCallback(function (item) {
    return !!selectedItems.find(function (selectedItem) {
      return selectedItem.id === item.id;
    });
  }, [selectedItems]);
  var addItem = useCallback(function (selectedItem) {
    var itemValues = selectedItems == null ? void 0 : selectedItems.map(function (item) {
      return item.value;
    });
    setSelectedItemValues([].concat(_toConsumableArray(itemValues), [selectedItem.value]));
    addSelectedItem(selectedItem);
    onSelect == null ? void 0 : onSelect(selectedItem.value);
  }, [addSelectedItem, onSelect, selectedItems]);
  var removeItem = useCallback(function (selectedItem) {
    setSelectedItemValues(selectedItems.filter(function (item) {
      return item.id !== selectedItem.id;
    }).map(function (item) {
      return item.value;
    }));
    removeSelectedItem(selectedItem);
  }, [removeSelectedItem, selectedItems]);
  var handleClear = useCallback(function () {
    setSelectedItemValues(null);
    selectedItems.forEach(function (selectedItem) {
      return removeSelectedItem(selectedItem);
    });
    onClear == null ? void 0 : onClear();
  }, [removeSelectedItem, selectedItems, onClear]);
  var handleConfirm = useCallback(function () {
    onConfirm == null ? void 0 : onConfirm(selectedItemValues);
  }, [onConfirm, selectedItemValues]);
  var handleSelection = useCallback(function (selectedItem) {
    if (isItemSelected(selectedItem)) {
      removeItem(selectedItem);
    } else if (selectionType === "single" && selectedItems.length) {
      reset();
      addItem(selectedItem);
    } else {
      addItem(selectedItem);
    }
  }, [addItem, isItemSelected, removeItem, selectionType, selectedItems, reset]);

  var handleInputChange = function handleInputChange(inputEvent) {
    var value = inputEvent.target.value;
    setInputValue(value);
    onSearch == null ? void 0 : onSearch(inputValue);
  };

  var handleReset = function handleReset() {
    setInputValue("");
    onReset == null ? void 0 : onReset();
  };

  var handleIsOpenChange = function handleIsOpenChange(_ref) {
    var isOpen2 = _ref.isOpen;

    switch (isOpen2) {
      case true:
        onOpen == null ? void 0 : onOpen();
        break;

      case false:
        onClose == null ? void 0 : onClose();
        break;
    }
  };

  var _useSelect = useSelect({
    items: items,
    selectedItem: null,
    stateReducer: function stateReducer(state, actionAndChanges) {
      var changes = actionAndChanges.changes,
          type = actionAndChanges.type;

      switch (type) {
        case useSelect.stateChangeTypes.ItemClick:
          return __spreadProps(__spreadValues({}, changes), {
            isOpen: true,
            highlightedIndex: state.highlightedIndex
          });

        case useSelect.stateChangeTypes.ToggleButtonBlur:
          return __spreadProps(__spreadValues({}, changes), {
            isOpen: false
          });
      }

      return __spreadProps(__spreadValues({}, changes), {
        isOpen: true
      });
    },
    onStateChange: function onStateChange(_ref2) {
      var type = _ref2.type,
          selectedItem = _ref2.selectedItem;

      switch (type) {
        case useSelect.stateChangeTypes.ItemClick:
          if (selectedItem) {
            handleSelection(selectedItem);
          }

          break;
      }
    },
    onIsOpenChange: handleIsOpenChange
  }),
      isOpen = _useSelect.isOpen,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      getItemProps = _useSelect.getItemProps;

  var getSelectionIcon = useCallback(function (item) {
    if (isItemSelected(item)) {
      return (
        /* @__PURE__ */
        React.createElement(CheckCircleFilled, {
          size: 22
        })
      );
    } else if (item.index === highlightedIndex) {
      return (
        /* @__PURE__ */
        React.createElement(CheckCircleOutlined, null)
      );
    }

    return void 0;
  }, [highlightedIndex, isItemSelected]);
  var getLabel = useCallback(function () {
    if (selectionType === "single") {
      if (selectedItems.length) {
        if (showSelectedItemAsLabel) {
          return selectedItems[0].displayValue;
        } else {
          return (
            /* @__PURE__ */
            React.createElement(React.Fragment, null, label,
            /* @__PURE__ */
            React.createElement(Badge, {
              content: 1,
              variant: "inverted",
              isRounded: true,
              size: "sm",
              ml: "xs"
            }))
          );
        }
      }
    } else if (selectionType === "multi") {
      if (selectedItems.length) {
        return (
          /* @__PURE__ */
          React.createElement(React.Fragment, null, label,
          /* @__PURE__ */
          React.createElement(Badge, {
            content: selectedItems.length.toString(10),
            variant: "inverted",
            isRounded: true,
            size: "sm",
            ml: "xs"
          }))
        );
      } else {
        return label;
      }
    }

    return label;
  }, [label, selectedItems, selectionType, showSelectedItemAsLabel]);
  useEffect(function () {
    _onChange == null ? void 0 : _onChange(selectedItemValues);
  }, [_onChange, selectedItemValues]);
  return (
    /* @__PURE__ */
    React.createElement(DropdownMenu, __spreadProps(__spreadValues({
      placement: "bottom-start"
    }, rest), {
      isOpen: isOpen
    }),
    /* @__PURE__ */
    React.createElement(DropdownMenu.Trigger, null, TriggerComponent ?
    /* @__PURE__ */
    React.createElement(TriggerComponent, __spreadValues({}, getToggleButtonProps(getDropdownProps({
      preventKeyAction: isOpen
    }, {
      suppressRefError: true
    }), {
      suppressRefError: true
    }))) :
    /* @__PURE__ */
    React.createElement(Button, __spreadValues({
      variant: "ghost",
      kind: triggerKind,
      size: "sm",
      isRounded: true,
      isDropdown: true
    }, getToggleButtonProps(getDropdownProps({
      preventKeyAction: isOpen
    }, {
      suppressRefError: true
    }), {
      suppressRefError: true
    })),
    /* @__PURE__ */
    React.createElement(Box, {
      display: "flex",
      alignItems: "center"
    }, getLabel()))),
    /* @__PURE__ */
    React.createElement(DropdownMenu.List, __spreadValues({}, getMenuProps({
      ref: listRef
    }, {
      suppressRefError: true
    })), isLoading &&
    /* @__PURE__ */
    React.createElement(Box, {
      flex: "1 1 auto",
      overflowY: "auto"
    },
    /* @__PURE__ */
    React.createElement(LoadingComponent, null)), !isLoading &&
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(Scrollable, {
      maxHeight: "340px"
    },
    /* @__PURE__ */
    React.createElement(Header, null, header &&
    /* @__PURE__ */
    React.createElement(Text, {
      size: "md",
      fontWeight: "bold",
      ml: "sm"
    }, header), isSearchable &&
    /* @__PURE__ */
    React.createElement(SearchInput, {
      mx: "sm",
      mb: "xs",
      mt: header ? "xs" : "none",
      placeholder: searchPlaceholder,
      onChange: handleInputChange,
      onReset: handleReset,
      value: inputValue
    }), subheader &&
    /* @__PURE__ */
    React.createElement(List.Subheader, null, subheader)), groupedItems.map(function (groupData, index) {
      return (
        /* @__PURE__ */
        React.createElement(Fragment, {
          key: index
        }, groupData.group &&
        /* @__PURE__ */
        React.createElement(List.Subheader, null, groupData.group.displayValue), groupData.items.map(function (item) {
          return (
            /* @__PURE__ */
            React.createElement(Item, __spreadValues({
              key: item.id,
              closeOnClick: selectionType === "single" ? true : false,
              isSelected: _selectionStyle === "default" ? isItemSelected(item) : false,
              disabled: item.isDisabled,
              addonLeft: _selectionStyle === "checkbox" &&
              /* @__PURE__ */
              React.createElement(FilterDropdownCheckbox, {
                label: "Select item",
                hideLabel: true,
                p: "none",
                isChecked: !!isItemSelected(item),
                onChange: function onChange() {
                  return _onChange == null ? void 0 : _onChange(selectedItemValues);
                }
              }),
              addonRight: _selectionStyle === "default" && getSelectionIcon(item)
            }, getItemProps({
              item: item,
              index: item.index
            })),
            /* @__PURE__ */
            React.createElement(ConditionalWrapper, {
              condition: item.wrapper,
              wrapper: item.wrapper
            }, item.displayValue))
          );
        }))
      );
    })), helpText &&
    /* @__PURE__ */
    React.createElement(Box, {
      height: "52px",
      mx: "sm",
      mt: "xs",
      mb: "xxs"
    },
    /* @__PURE__ */
    React.createElement(Text, {
      size: "sm",
      contrast: "low"
    }, helpText)), hasFooter &&
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(DropdownMenu.Divider, null),
    /* @__PURE__ */
    React.createElement(Footer, null,
    /* @__PURE__ */
    React.createElement(Level.Left, null,
    /* @__PURE__ */
    React.createElement(Button, {
      variant: "ghost",
      kind: "link",
      onClick: handleClear
    }, clearLabel)),
    /* @__PURE__ */
    React.createElement(Level.Right, null,
    /* @__PURE__ */
    React.createElement(Button, {
      variant: "secondary",
      isRounded: true,
      size: "sm",
      onClick: handleConfirm
    }, confirmLabel)))), !!React.Children.count(footer) &&
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(DropdownMenu.Divider, null), footer))))
  );
};

FilterDropdownBase.displayName = "FilterDropdown";
var FilterDropdown = Object.assign(FilterDropdownBase, {
  Item: Item,
  Footer: Footer
});
export { FilterDropdown, FilterDropdownBase };